import logger from "../logging/logger";

export function url_creation(resName, resourceIdOrQuery = "", maybeQuery = "") {
    let resourceId = "";
    let query = "";
    let headers = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: global.auth.authToken.token,
            firmenid: global.filterFirmenId,
        },
    };
    //Query könnte auch ein Objekt sein, daher erst in String wandeln
    if (typeof resourceIdOrQuery === "object") {
        logger.log("Object Query:", resourceIdOrQuery);
        resourceIdOrQuery = queryObjectToString(resourceIdOrQuery, resName);
    }

    // Determine which parameter is which
    if (
        typeof resourceIdOrQuery === "string" &&
        resourceIdOrQuery.startsWith("?")
    ) {
        query = resourceIdOrQuery;
    } else {
        resourceId = resourceIdOrQuery !== "" ? "/" + resourceIdOrQuery : "";
        if (typeof maybeQuery === "object" && maybeQuery !== null) {
            logger.log("Maybe Object Query:", maybeQuery);
            query = queryObjectToString(maybeQuery, resName);
        } else {
            query = maybeQuery || ""; // Falls `maybeQuery` leer ist, ersetze es durch ''
        }
    }

    return {
        url: global.api_url + resName + resourceId + query,
        resourceId,
        query,
        headers,
    };
}

/**
 *
 * @param {Resouce Name} resName
 * @param {id for single, can be empty} resourceId
 * @param {query Params} query
 */
export async function fetchApi(
    resName,
    resourceIdOrQuery = "",
    maybeQuery = "",
    retries = 3,
) {
    const { url, resourceId, query, headers } = url_creation(
        resName,
        resourceIdOrQuery,
        maybeQuery,
    );

    for (let attempt = 0; attempt <= retries; attempt++) {
        try {
            const res = await fetch(url, headers);
            if (!res.ok) {
                if (res.status === 429) {
                    // 429 = Too Many Requests
                    let retryAfter =
                        parseInt(res.headers.get("Retry-After") || "1", 10) *
                        1000;
                    console.warn(
                        `Rate Limit erreicht, warte ${retryAfter}ms...`,
                    );
                    await new Promise((resolve) =>
                        setTimeout(resolve, retryAfter),
                    );
                    continue; // Wiederhole die Anfrage
                }
                const errorBody = await res.json();
                throw new Error(
                    `Fehler: ${res.status}, ${JSON.stringify(errorBody)}`,
                );
            }
            return await res.json();
        } catch (err) {
            console.error(`Fehler bei Versuch ${attempt + 1}:`, err);
            if (attempt === retries) throw err; // Letzter Versuch, Fehler weiterwerfen
        }
    }
}

/**
 *
 * @param {*} resName
 * @param {*} resourceId
 * @param {*} data
 * @returns Promise(resolve(response.json), reject(err))
 */
export async function putApi(resName, resourceId = "", data) {
    let headers = {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: global.auth.authToken.token,
        },
    };
    headers.body = JSON.stringify(data);

    // logger.log('ketest', headers.body)

    if (resourceId !== "") resourceId = "/" + resourceId;

    let resp = await fetch(global.api_url + resName + resourceId, headers);
    let res = await resp.json();
    if (!resp.ok) {
        throw new Error(res.error);
    }
    return res;
}

export async function saveApi(resName, data) {
    let headers = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: global.auth.authToken.token,
        },
    };
    headers.body = JSON.stringify(data);
    return new Promise((resolve, reject) => {
        fetch(global.api_url + resName, headers)
            .then(async (res) => {
                const response = await res.json().catch(() => ({}));
                if (!res.ok) {
                    return reject(
                        new Error(response.message || `HTTP ${res.status}`),
                    );
                }
                return resolve(response);
            })
            .catch((err) => {
                return reject(err);
            });
    });
}

export async function deleteApi(resName, resourceId) {
    let headers = {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Authorization: global.auth.authToken.token,
            firmenid: global.filterFirmenId,
        },
    };

    return new Promise((resolve, reject) => {
        fetch(global.api_url + resName + "/" + resourceId, headers)
            .then((res) => res.json())
            .then((response) => {
                // logger.log('delete ok')
                return resolve(response);
            })
            .catch((err) => {
                logger.log("err", err);
                return reject(err);
            });
    });
}

/**
 * Partielle Aktualisierung (PATCH) eines Ressourcen-Objekts.
 * @param {string} resName – Name der Resource (z.B. "mitarbeiter")
 * @param {string|number} resourceId – ID des zu patchenden Objekts
 * @param {object} data – Die Felder, die geändert werden sollen
 * @returns {Promise<object>} – Die geparste JSON-Antwort der API
 */
export async function patchApi(resName, resourceId = "", data) {
    // Header mit PATCH-Methode
    const headers = {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            Authorization: global.auth.authToken.token,
            firmenid: global.filterFirmenId,
        },
        body: JSON.stringify(data),
    };

    // Resource-Pfad bauen
    const idPath = resourceId !== "" ? `/${resourceId}` : "";
    const url = `${global.api_url}${resName}${idPath}`;

    // Anfrage senden
    const resp = await fetch(url, headers);
    const res = await resp.json();

    if (!resp.ok) {
        // Wirft den Fehler-Text, falls HTTP-Status ≠ 2xx
        throw new Error(
            res.error || res.message || `PATCH ${resName}${idPath} failed`,
        );
    }

    return res;
}

// Interne Helper Functions
// Report-Zweige (CSV-Export-Dialog) lesen fields/from/to/status/includeNoTerm
// als nackte Params; die Widget-Controller lesen dagegen filterby_status —
// darum ist die Erweiterung an die Dialog-Endpunkte gebunden
const NACKTE_QUERY_KEYS = [
    "sortOrder",
    "orderBy",
    "limit",
    "currentPage",
    "format",
    "metaCols",
];
const DIALOG_QUERY_KEYS = ["fields", "from", "to", "status", "includeNoTerm"];
const DIALOG_QUERY_ENDPOINTS = ["report/mitarbeiter_uebersicht", "mitarbeiter"];

function queryObjectToString(query, resName = "") {
    if (!query || typeof query !== "object") {
        logger.error(
            "queryObjectToString: Ungültiges Query-Objekt, setze leeres Objekt.",
        );
        return ""; // Falls `query` nicht definiert ist, einfach leeren String zurückgeben
    }
    const params = new URLSearchParams();
    const dialogQuery = DIALOG_QUERY_ENDPOINTS.includes(resName);
    for (const [key, value] of Object.entries(query)) {
        if (value !== undefined) {
            if (
                NACKTE_QUERY_KEYS.includes(key) ||
                (dialogQuery && DIALOG_QUERY_KEYS.includes(key))
            ) {
                params.append(key, value);
            } else {
                params.append("filterby_" + key, value);
            }
        }
    }
    return params.toString() !== "" ? "?" + params.toString() : "";
}
